import { render } from "./SessionNav.vue?vue&type=template&id=3dab16ff&scoped=true"
const script = {}

import "./SessionNav.vue?vue&type=style&index=0&id=3dab16ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dab16ff"]])

export default __exports__